import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import "./styles.scss";

export const Box = ({
  className,
  direction,
  wrap,
  children,
  tag,
  justifyContent,
  alignContent,
  alignItems,
  position,
}) =>
  React.createElement(
    tag,
    {
      className: classNames(className, "flex-container", {
        "flex-direction-row": direction === "row",
        "flex-direction-column": direction === "column",
        "flex-wrap": !!wrap,
      }),
      style: {
        justifyContent,
        alignContent,
        alignItems,
      },
    },
    children
  );

Box.propTypes = {
  direction: PropTypes.oneOf(["row", "column"]),
  className: PropTypes.string,
  wrap: PropTypes.bool,
  children: PropTypes.node,
  tag: PropTypes.string,
  justifyContent: PropTypes.oneOf([
    "flex-start",
    "flex-end",
    "center",
    "space-between",
    "space-around",
  ]),
  alignItems: PropTypes.oneOf([
    "flex-start",
    "flex-end",
    "stretch",
    "center",
    "baseline",
  ]),
  alignContent: PropTypes.oneOf([
    "flex-start",
    "flex-end",
    "stretch",
    "space-between",
    "space-around",
  ]),
  position: PropTypes.oneOf(["relative", "absolute"]),
};

Box.defaultProps = {
  tag: "div",
};

export default Box;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/layout/Box/index.js